// Access gate for the new Mushtarek landing page.
//
// Requirement:
//   staging.newssocial.uk/landing  -> shown (staging is one shared testing
//                                     environment for every white-label, so
//                                     any staging host shows the page; there
//                                     is no separate staging.mushtarek.org)
//   mushtarek.org/landing          -> shown (live in production)
//   newssocial.news/landing        -> hidden
//   iraqmanara.org/landing         -> hidden
//
// i.e. staging/local: always; production: Mushtarek only. Kept as pure
// functions so the logic is unit-testable and runs identically on the server
// and the client.

// The host is available on the server via opts.req.hostname and on the client
// via window.location. Resolving it this way keeps the gate SSR-safe, so the
// page is hidden during server render too (not just after client hydration).
export const resolveHost = (opts?: { req?: { hostname?: string } }): string => {
  if (opts && opts.req && opts.req.hostname) return String(opts.req.hostname)
  if (typeof location !== 'undefined') return location.hostname
  return ''
}

interface InstanceLike {
  instanceName?: string
  domainName?: string
}

export const canShowMushtarekLanding = (host: string, instance?: InstanceLike): boolean => {
  const h = (host || '').toLowerCase()

  // Staging/local: always shown, regardless of which tenant the host resolves
  // to, because staging is a single shared environment across white-labels.
  if (h.startsWith('localhost') || h.startsWith('192.') || h.startsWith('staging')) {
    return true
  }

  // Production: Mushtarek only. Every other white-label (newssocial.news,
  // iraqmanara.org, argon.today, ...) falls back to its own /welcome page.
  // The instance is checked too, so a Mushtarek deployment served on another
  // hostname still resolves correctly.
  const instanceName = String((instance && instance.instanceName) || '').toLowerCase()
  const domainName = String((instance && instance.domainName) || '').toLowerCase()
  return (
    h.includes('mushtarek') ||
    instanceName.includes('mushtarek') ||
    domainName.includes('mushtarek')
  )
}
